import { AVA_PICTURE_DISPLAY_NAME } from "./core";
import createDisplayName from "../../../fabrics/createDisplayName";

export const createDisplayNameForAvaPictureElement = createDisplayName(
    AVA_PICTURE_DISPLAY_NAME,
);
